import React from 'react';
import { ShortSubscriptions } from '../../../utils/user-subscription';
import './ProBadge.scss';

export default class ProBadgePure extends React.PureComponent {
  render() {
    const { subscriptions, adviserSubscriptionNickname, explicitShow, onClick, actionLabel } = this.props;

    const visible =
      (explicitShow === undefined &&
        (new ShortSubscriptions(subscriptions).containTypedSubscription({
          type: 'core',
          nicknames: ['Pro', 'Ultra']
        }) ||
          adviserSubscriptionNickname === 'Pro' ||
          adviserSubscriptionNickname === 'Ultra')) ||
      (explicitShow !== undefined && explicitShow);

    if (!visible) return null;

    // Decorative by default — it only states the plan. A caller that passes
    // `onClick` is attaching an action to it (the client page uses it as the
    // way into ClientV2), and then it has to be a real button so keyboard and
    // screen-reader users get the same affordance, with `actionLabel` naming
    // what it does rather than leaving them just the word "PRO".
    if (!onClick) return <span className="pro-badge">PRO</span>;

    return (
      <button
        type="button"
        className="pro-badge is-actionable"
        aria-label={actionLabel}
        title={actionLabel}
        onClick={onClick}
      >
        PRO
      </button>
    );
  }
}
